<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="用户ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>

      <el-table-column label="用户微信" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.user.avatar" class="user-avatar">
            <span>{{ scope.row.user.nickname }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.name }}
        </template>
      </el-table-column>

      <el-table-column label="备注" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark }}
        </template>
      </el-table-column>

      <el-table-column label="统计店铺" min-width="150" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-for="(item,index) in scope.row.shops" :key="index" style="margin: 3px;">{{item.shop_name}}（{{item.school.school_name}}）</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>

          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="绑定用户" prop="user_id">
          <el-select v-model="form.user_id" placeholder="输入昵称/手机号/姓名进行搜索" filterable remote :remote-method="userFilter"  :loading="userFilterLoading" style="width:340px" clearable>
            <el-option v-for="item in users" :key="item.id" :label="item.nickname" :value="item.id">
              <div style="display: flex;align-items:center;text-align:center;">
                <img :src="item.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
                <span>{{ item.nickname }} / {{item.phone}} / {{item.name}}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="统计店铺" prop="shop_ids">
          <el-tree :data="schoolWithShops" show-checkbox default-expand-all node-key="treeId" ref="treeShops" @check-change="treeChange"></el-tree>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="255" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  import { guid } from "@/utils/index";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          school_id: "",
          user_id: "",
          shop_ids: [],
          remark: "",
        },
        rules: {
          user_id: [{ required: true, message: "用户不能为空", trigger: "change" }],
        },
        users: [],
        userFilterLoading: false,
        shop_type: 1,
        schoolWithShops: [],
        treeIds: [],
      };
    },
    created() {
      this.getList();
      this.getSchoolWithShop();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getSchoolWithShop();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/statisticalPersonnel/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.items;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          user_id: "",
          shop_ids: [],
          remark: "",
        }
        this.btnLoading = false
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
        this.userFilter(row.user.phone)

        let treeIds = [];
        // 区分外卖与商城
        if (this.shop_type === 1) {
          this.schoolWithShops.forEach(element => {
            element.children.forEach(element2 => {
              element2.children.forEach(element3 => {
                if (this.form.shop_ids.indexOf(element3.id) > -1) {
                  treeIds.push(element3.treeId);
                }
              });
            });
          });
        } else if(this.shop_type === 2) {
          this.schoolWithShops.forEach(element => {
            element.children.forEach(element2 => {
              if (this.form.shop_ids.indexOf(element2.id) > -1) {
                treeIds.push(element2.treeId);
              }
            });
          });
        }
        setTimeout(()=>{this.$refs.treeShops.setCheckedKeys(treeIds);},0)
      },
      saveData() {
        if (!this.school_id) {
          this.$message({
            type: "warning",
            message: "请选择学校"
          });
          return;
        } else {
          this.form.school_id = this.school_id;
        }

        let shop_ids = [];
        // 区分外卖与商城
        if (this.shop_type === 1) {
          this.schoolWithShops.forEach(element => {
            element.children.forEach(element2 => {
              element2.children.forEach(element3 => {
                if (this.treeIds.indexOf(element3.treeId) > -1) {
                  shop_ids.push(element3.id);
                }
              });
            });
          });
        } else if(this.shop_type === 2) {
          this.schoolWithShops.forEach(element => {
            element.children.forEach(element2 => {
              if (this.treeIds.indexOf(element2.treeId) > -1) {
                shop_ids.push(element2.id);
              }
            });
          });
        }
        this.form.shop_ids = shop_ids;

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/statisticalPersonnel/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
      handleDelete(row) {
        this.$confirm("确认继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/statisticalPersonnel/delete",
            method: "post",
            data: {
              id: row.id
            }
          }).then(()=>{
            this.getList();
            this.list.length <= 1 && this.listQuery.page > 1 ? this.listQuery.page-- : false;
            this.$message({
              type: "success",
              message: "操作成功"
            });
          })
        }).catch(() => {});
      },
      userFilter(val) {
        this.userFilterLoading = true
        request({
          url: "/api/backend/user/list",
          method: "get",
          params: {
            page: 1,
            limit: 10,
            // school_id: this.school_id,
            keyword: val,
          }
        }).then(response => {
          this.users = response.data.data;
        }).finally(()=>{
          this.userFilterLoading = false
        })
      },
      getSchoolWithShop() {
        if (!this.school_id) {
          return;
        }
        request({
          url: "/api/backend/school/schoolWithShop",
          method: "get",
          params: {
            // school_id: this.school_id,
            type: this.shop_type
          }
        }).then(response => {
          let data = response.data;
          let schoolWithShops = [];

          // 区分外卖与商城
          if (this.shop_type === 1) {
            data.forEach(element => {
              let obj = {
                treeId: guid(),
                id: element.id,
                label: element.school_name,
                children: []
              };
              element.canteens.forEach(element2 => {
                let obj2 = {
                  treeId: guid(),
                  id: element2.id,
                  label: element2.canteen_name,
                  children: []
                };
                element2.shops.forEach(element3 => {
                  let obj3 = {
                    treeId: guid(),
                    id: element3.id,
                    label: element3.shop_name,
                    children: []
                  };
                  obj2.children.push(obj3);
                });
                obj.children.push(obj2);
              });
              schoolWithShops.push(obj);
            });
          } else if(this.shop_type === 2) {
            data.forEach(element => {
              let obj = {
                treeId: guid(),
                id: element.id,
                label: element.school_name,
                children: []
              };
              element.shop_list.forEach(element2 => {
                let obj2 = {
                  treeId: guid(),
                  id: element2.id,
                  label: element2.shop_name,
                  children: []
                };
                obj.children.push(obj2);
              });
              schoolWithShops.push(obj);
            });
          }

          this.schoolWithShops = schoolWithShops;
        });
      },
      treeChange(target, currentCheck, childCheck) {
        let index = this.treeIds.indexOf(target.treeId);
        if (currentCheck) {
          if (index < 0) {
            this.treeIds.push(target.treeId);
          }
        } else {
          if (index > -1) {
            this.treeIds.splice(index, 1);
          }
        }
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
